import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=151a406e"
import script from "./SearchBar.ts?vue&type=script&lang=ts&external"
export * from "./SearchBar.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports